var _circle, _circle2, _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _rect4, _ellipse, _path5, _rect5, _rect6, _g, _circle3, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 320,
    viewBox: "0 0 464 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 160,
    r: 160,
    fill: "#2396FF",
    fillOpacity: 0.32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 160,
    r: 138,
    fill: "#2396FF",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 266C212.541 259.519 160 233.433 160 180.936C160 128.44 160.812 97.2231 162.031 88.1766C168.802 85.7462 188.762 80.2373 201.437 77.6449C225.198 72.785 250.801 72.785 274.562 77.6449C287.237 80.2373 307.197 85.7462 313.968 88.1766C315.187 97.2231 316 128.44 316 180.936C316 233.433 263.458 259.519 238 266Z",
    fill: "#2396FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 253C216.131 247.397 171 224.843 171 179.455C171 134.068 171.697 107.078 172.744 99.2569C178.56 97.1556 195.706 92.3927 206.593 90.1513C227.004 85.9496 248.995 85.9496 269.406 90.1513C280.293 92.3927 297.439 97.1556 303.255 99.2569C304.302 107.078 305 134.068 305 179.455C305 224.843 259.868 247.397 238 253Z",
    fill: "#2396FF",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 147,
    width: 65,
    height: 52,
    rx: 10,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219 147V137C219 128.163 226.163 121 235 121H242C250.836 121 258 128.163 258 137V147",
    stroke: "black",
    strokeOpacity: 0.72,
    strokeWidth: 12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.327 175.004C243.947 173.822 245 171.909 245 169.75C245 166.16 242.089 163.25 238.5 163.25C234.91 163.25 232 166.16 232 169.75C232 171.909 233.052 173.822 234.672 175.004L233.899 181.319C233.753 182.511 234.683 183.562 235.884 183.562H241.115C242.316 183.562 243.246 182.511 243.1 181.319L242.327 175.004Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169.784,
    y: 229,
    width: 36.4576,
    height: 168.784,
    rx: 7,
    transform: "rotate(90 169.784 229)",
    fill: "#F0F8FF",
    stroke: "#89C6FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 41,
    width: 126.088,
    height: 83.4613,
    rx: 7,
    fill: "#F0F8FF",
    stroke: "#89C6FF",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 343.539,
    y: 48.5464,
    width: 51.2351,
    height: 51.2767,
    rx: 4,
    fill: "#89C6FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.087,
    cy: 65.1348,
    rx: 9,
    ry: 9.5,
    fill: "#B9DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.087 86.5245C386.087 92.8754 378.476 92.6336 369.087 92.6336C359.699 92.6336 352.087 92.8754 352.087 86.5245C352.087 80.1736 359.699 69.6348 369.087 69.6348C378.476 69.6348 386.087 80.1736 386.087 86.5245Z",
    fill: "#B9DDFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 402.601,
    y: 64.2139,
    width: 51.2351,
    height: 7.12177,
    rx: 3,
    fill: "#89C6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 402.601,
    y: 77.0332,
    width: 28.464,
    height: 7.12178,
    rx: 3,
    fill: "#89C6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 244,
    width: 14,
    height: 12,
    rx: 2,
    fill: "#89C6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 246V242C17 239.791 18.7909 238 21 238V238C23.2091 238 25 239.791 25 242V246",
    stroke: "#89C6FF",
    strokeWidth: 2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.292,
    cy: 247,
    r: 7,
    fill: "#89C6FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.292,
    cy: 247,
    r: 7,
    fill: "#89C6FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.292,
    cy: 247,
    r: 7,
    fill: "#89C6FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.292,
    cy: 247,
    r: 7,
    fill: "#89C6FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.292,
    cy: 247,
    r: 7,
    fill: "#89C6FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLock);
export default __webpack_public_path__ + "static/media/img_lock.95d120e6a6ae464f843a7064f1b041b2.svg";
export { ForwardRef as ReactComponent };